import {
    FURUI_SUBMIT_FRUI_PLAN_BEGIN,
    FURUI_SUBMIT_FRUI_PLAN_SUCCESS,
    FURUI_SUBMIT_FRUI_PLAN_FAILURE,
    FURUI_SUBMIT_FRUI_PLAN_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_plan(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: FURUI_SUBMIT_FRUI_PLAN_BEGIN,
      });
  
      let apiurl = '/api/b/frui_plan/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/frui_plan/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: FURUI_SUBMIT_FRUI_PLAN_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: FURUI_SUBMIT_FRUI_PLAN_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_planError() {
    return {
      type: FURUI_SUBMIT_FRUI_PLAN_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case FURUI_SUBMIT_FRUI_PLAN_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_planPending: true,
          submitFrui_planError: null,
        };
  
      case FURUI_SUBMIT_FRUI_PLAN_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_planPending: false,
          submitFrui_planError: null,
        };
  
      case FURUI_SUBMIT_FRUI_PLAN_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_planPending: false,
          submitFrui_planError: action.data.error,
        };
  
      case FURUI_SUBMIT_FRUI_PLAN_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_planError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/furui/redux/submitFrui_plan.js